import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserTransaction`;


function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiUserTransaction = {
  getAllUserTransaction: (params) => {
    const url = `${baseServiceUrl}/getAllUserTransaction` + paramsToStringList(params);
    return ServiceApi.get(url, { params });
  },
  getUserTransactionById: (params) => {
    const url = `${baseServiceUrl}/getUserTransactionById?id=` + params;
    return ServiceApi.get(url, params);
  },
  getUserTransactionStatus: (params) => {
    const url = `${baseServiceUrl}/getUserTransactionStatus`;
    return ServiceApi.get(url, { params });
  },
  getAllSupplierTransactions: (params) => {
    const url = `${baseServiceUrl}/GetAllSupplierTransaction`;
    return ServiceApi.get(url, { params });
  },

};

export default ApiUserTransaction;


